import { Quote, Star } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";

const TESTIMONIALS = [
  {
    quote: "Tsugiva's finger turmeric consistently tests above 5% curcumin. Three seasons in, their lot-to-lot consistency is the best we have sourced from India.",
    name: "Daniel Okafor",
    role: "Procurement Head, Spice Importer — Lagos",
    type: "Import Buyer",
  },
  {
    quote: "The groundnut oil smells exactly like what my grandmother used. You can tell it's pressed slow — my dosas have never crisped better.",
    name: "Lakshmi Venkat",
    role: "Home Customer — Hyderabad",
    type: "Home Kitchen",
  },
  {
    quote: "Documentation, fumigation certificates, loading supervision — everything was handled before we even asked. A genuinely professional export desk.",
    name: "Thomas Weber",
    role: "Managing Director, Food Ingredients — Hamburg",
    type: "Import Buyer",
  },
  {
    quote: "Ordered the 1L coconut oil over email and it arrived in three days, beautifully packed. Using it for cooking and for my daughter's hair.",
    name: "Anitha Reddy",
    role: "Home Customer — Bengaluru",
    type: "Home Kitchen",
  },
  {
    quote: "The groundnut oil arrived with full lab reports and beautiful packaging. Our retail customers noticed the aroma difference within the first month.",
    name: "Meera Krishnan",
    role: "Founder, Organic Retail Chain — Dubai",
    type: "Import Buyer",
  },
  {
    quote: "Switched my whole kitchen to Tsugiva sesame oil for podis and pickles. The nuttiness is on another level compared to store-bought refined oil.",
    name: "Karthik Sharma",
    role: "Home Customer — Chennai",
    type: "Home Kitchen",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="bg-cream py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="text-center">
          <Eyebrow>Client Voices</Eyebrow>
          <h2 className="mx-auto mt-3 max-w-2xl font-serif text-3xl font-semibold leading-tight text-ink sm:text-4xl lg:text-5xl">
            Loved by home kitchens, trusted by importers
          </h2>
          <div className="mt-4 flex items-center justify-center gap-2">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={18} className="fill-gold text-gold" />
            ))}
            <span className="ml-1 text-sm font-medium text-smoke">Rated by families, distributors & food processors alike</span>
          </div>
        </Reveal>
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={(i % 3) * 0.1} className="h-full">
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className="flex h-full flex-col rounded-2xl border border-stone2 bg-white p-8 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_-20px_rgba(26,23,20,0.25)]"
              >
                <div className="flex items-center justify-between">
                  <Quote size={28} className="text-gold" />
                  <span className={`rounded-full px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] ${
                    t.type === "Home Kitchen" ? "bg-gold/15 text-gold" : "bg-botanical/10 text-botanical"
                  }`}>
                    {t.type}
                  </span>
                </div>
                <div className="mt-4 flex gap-1">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={14} className="fill-gold text-gold" />
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-smoke sm:text-base">
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-6 border-t border-stone2 pt-5">
                  <div className="font-serif text-base font-semibold text-ink">{t.name}</div>
                  <div className="mt-0.5 text-xs uppercase tracking-[0.12em] text-pebble">{t.role}</div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
